module.exports = __webpack_public_path__ + "img/trade-img-8coin.9a53d205.png";